import { render, staticRenderFns } from "./addNoticUser.vue?vue&type=template&id=6cc80923&scoped=true&"
import script from "./addNoticUser.vue?vue&type=script&lang=js&"
export * from "./addNoticUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc80923",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cc80923')) {
      api.createRecord('6cc80923', component.options)
    } else {
      api.reload('6cc80923', component.options)
    }
    module.hot.accept("./addNoticUser.vue?vue&type=template&id=6cc80923&scoped=true&", function () {
      api.rerender('6cc80923', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/components/addNoticUser.vue"
export default component.exports